// extracted by mini-css-extract-plugin
module.exports = {"footer":"TQ9_z_0M","wrap":"nXGKTF7d","logo":"eCSsEp7j","section":"__2CimMhh_","icp":"uEKkbtfa","company":"M_yTat52","filing":"__4MEV9cGi","record":"giDllMm2","protocol":"BghnoMSq"};